<script setup>
defineProps({
  link: { type: String, default: null },
  direction: { type: String, default: null },
  col: { type: String, default: null },
  text: { type: String, default: null },
  type: { type: String, default: '', required: false }
})
const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
</script>

<template>
  <NuxtLink
    class="moreButton"
    :to="`${isWebViewFlag ? `${runtimeConfig.app.baseURL}${link.replace(/^\//, '')}` : link}`"
    :external="isWebViewFlag"
    :data-dir="direction"
    :data-color="col"
    :data-type="type"
  >
    <span class="text">{{ text }}</span>
    <span
      v-if="direction"
      class="image"
    >
      <img
        v-if="type === 'golf'"
        src="https://gvs.weathernews.jp/golf/image/common/icon_arrow_blue_circle.svg"
        width="24"
        height="24"
        alt=""
      >
      <img
        v-else
        src="https://gvs.weathernews.jp/onebox/img/common/icon_arrow.svg"
        width="24"
        height="24"
        alt=""
      >
    </span>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.moreButton {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 7px;
  border-radius: 40px;
  border: solid 2px #fff;
  box-shadow: 0 2px 4px 0 rgba(#000, .15);
  cursor: pointer;
  .text {
    flex: 1;
    font-size: 12px;
    font-weight: bold;
    line-height: 12px;
  }
  .image {
    width: 24px;
    height: 24px;
    transform-origin: center;
  }
  &[data-color="white"] {
    background: #eef1f8;
    .text {
      color: #3569c0;
    }
  }
  &[data-color="blue"] {
    background: #438fec;
    .text {
      color: #fff;
    }
  }
  &[data-dir="bottom"] {
    .image {
      transform: rotate(90deg);
    }
  }
  &[data-dir="top"] {
    .image {
      transform: rotate(-90deg);
    }
  }
  &[data-type="golf"] {
    border-color: #3569C0;
    background-color: #fff !important;
    box-shadow: none;
  }
  @media screen and (min-width: 830px) {
    transition: box-shadow .2s ease-in-out;
    &:hover {
      box-shadow: 0 2px 6px 0 rgba(#000, .45);
    }
  }
  @media screen and (min-width: 830px) {
    padding: 5px 20px 3px 20px;
    .text {
      font-size: 16px;
    }
    &[data-type="golf"] {
      padding-top: 2px;
      padding-bottom: 1px;
    }
  }
}
</style>
